import DisplayWinner from './DisplayWinner';

customElements.define('display-winner', DisplayWinner);
